<template>
  <div class="our aboutUs">
     <template v-if='id==1'>
       <p class="our_common_title">BISAZZA质保说明</p>
       <div class="aboutUs_detail">
         <div class="aboutUs_item">

           <div class="aboutUs_item_text">
             上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球品质的纯进口卫浴产品及一站式系统服务。
           </div>
         </div>
       </div>
     </template>
     <template v-if='id==2'>
       <p class="our_common_title">卫浴质保说明</p>
       <div class="aboutUs_detail">
         <div class="aboutUs_item">

           <div class="aboutUs_item_text">
             上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球品质的纯进口卫浴产品及一站式系统服务。
           </div>
         </div>
       </div>
     </template>
     <template v-if='id==3'>
       <p class="our_common_title">户外SPA质保说明</p>
       <div class="aboutUs_detail">
         <div class="aboutUs_item">

           <div class="aboutUs_item_text">
             上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球品质的纯进口卫浴产品及一站式系统服务。
           </div>
         </div>
       </div>
     </template>
  </div>
</template>

<script>
/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
export default {
  name: 'app',
  data(){
    return{
      cremq:false,
      cpcs:true,
      id:''
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){
    this.id=this.$route.params.id
  }
}
</script>

<style scoped>
.aboutUs{

}
.banner{
  width: 100%;
  display: block;
}
.our_common_title{
  font-size: 0.36rem;
  font-weight: bold;
  color: #000;
  padding:0.3rem 0.2rem 0.5rem;
}


.aboutUs_item_text{
  font-size: 0.24rem;
  color: #000;
  line-height: 200%;
  padding: 0rem 0.2rem;
  box-sizing: border-box;
}
.core_item{
  padding: 0.26rem 0;
  border-bottom: 1px dashed #d4d4d4;
}
.core_item:first-child{
  padding-top: 0;
}
.core2{
  width: 5.49rem;
}
.aboutUs_item_text .service{
  line-height: 300%;
}
.aboutUs_item_text .service a{
  color: #3478f7;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/customer_s.vue